import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Fiat } from "@models";
import { Tradable } from "@modules/+new/core/tradables/domain/entities/tradable";
import { IUnstakingItem } from "@modules/staking/domain/entities/unstaking-item.model";
import { EMPTY, Observable, map, takeWhile, timer } from "rxjs";

@Component({
	selector: "unstaking-countdown-item",
	templateUrl: "./unstaking-countdown-item.component.html",
	styleUrls: ["./unstaking-countdown-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class UnstakingCountdownItemComponent {
	public showItem: boolean = true;
	@Input() set data(data: IUnstakingItem) {
		this.unstackingData = data;
		if (this.getTimeDifferenceFromNow(data.releaseTimeStamp) > 0) {
			this.progress$ = this.getTimer$(data.releaseTimeStamp);
		}
	}

	@Input() public tradable: Tradable;
	@Input() public defaultFiat: Fiat;
	@Output() public countdownEnd = new EventEmitter<boolean>();

	public progress$: Observable<number> = EMPTY;
	public unstackingData: IUnstakingItem;

	public getTimer$(startTime: number): Observable<number> {
		return timer(0, 1000).pipe(
			map(() => {
				// instead of counting down, recalculate (and recalibrate) remaining time every second
				const timeDifference = this.getTimeDifferenceFromNow(startTime);

				// if countdown is complete, emit and then unsub in next step
				if (timeDifference === 0) {
					this.showItem = false;
					this.countdownEnd.emit(true);
					return null;
				}

				// return progress bar value
				return this.progressCalculations(this.unstackingData.releaseTimeStamp, this.unstackingData.createdTime);
			}),
			// unsubscribe when countdown is completed
			// "true" flag says to also emit the value that caused the condition to be false (we want to display the last 0 in the countdown)
			takeWhile((timeDifference) => timeDifference >= 0, true)
		);
	}

	private getTimeDifferenceFromNow(startTime: number): number {
		const diff = Math.round((startTime - new Date().getTime()) / 1000);
		return Math.max(0, diff);
	}

	private progressCalculations(finalTimeStamp: number, createdTimeStamp: number): number {
		const overallDuration = Math.round(finalTimeStamp - Number(createdTimeStamp)) / 1000;
		const durationFromNow = Math.ceil(Math.max(0, Math.fround(finalTimeStamp - Date.now()) / 1000));

		const dd = overallDuration - durationFromNow;
		return Math.ceil((dd / overallDuration) * 100);
	}
}
